import { IconPresentationProps } from "@insite/mobius/Icon";
import * as React from "react";

const Twitter: React.FC<IconPresentationProps> = props => {
    return (
        <svg
            focusable="false"
            xmlns="http://www.w3.org/2000/svg"
            width="32"
            height="32"
            viewBox="0 0 32 32"
            fill="currentColor"
            fillRule="nonzero"
            stroke="none"
            role="img"
        >
            {props.title && <title>{props.title}</title>}
            <path d="M 1.5e-7,1.25e-7 V 32 H 32 V 1.25e-7 Z M 4.0000001,4.0000001 h 7.0996089 l 6.300782,8.8007809 7.699218,-8.8007809 h 2.09961 L 18.300781,14.199219 28,28 h -7.199219 l -6.5,-9.300781 L 6.0996088,28 H 4.0000001 L 13.400391,17.300781 Z M 6.9003909,5.5996095 14.5,16.099609 15.400391,17.400391 21.800781,26.5 H 25 l -7.900391,-11.099609 -0.90039,-1.300782 -6.09961,-8.4999995 z" />
        </svg>
    );
};

export default React.memo(Twitter);
